import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import EmployeeApp from "./EmployeeApp";
import { makeEmployeeClient } from "./employeeApi";

// Real employee app at /medarbejder — fills the device screen (no phone frame).
export default function EmployeeLayout() {
    const { user, loading, logout } = useAuth();
    const navigate = useNavigate();
    const client = useMemo(() => makeEmployeeClient(api), []);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if ((user.role || "").toLowerCase() !== "medarbejder") return <Navigate to="/dashboard" replace />;

    const doLogout = () => { logout(); navigate("/login", { replace: true }); };

    return (
        <div className="h-[100dvh] w-full bg-slate-50" data-testid="employee-layout">
            <EmployeeApp client={client} onLogout={doLogout} />
        </div>
    );
}
